import React, { useState } from 'react';
import {Space, Tooltip, Modal, Menu, Dropdown } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from "@mui/material/ButtonGroup";
import {LockRounded, LockOpenRounded, TrendingUpRounded, TrendingDownRounded, BalanceRounded, EqualizerRounded,
ExpandMore, AddCircleRounded, CreateNewFolderRounded, ScaleRounded, SearchRounded } from "@mui/icons-material";
import TickerSearch from "../../../Components/TickerSearch/TickerSearch";
import PortfolioSelector from "../../../Pages/Portfolio/PortfolioSelector";
import ScaleEntry  from "./ScaleEntry";



const getAllowedTypes = (builderType)=>{
    if (builderType==='m'){
        return ['b', 's']
    }
    if (builderType==='s'){
        return ['b'];
    }
    return [];
}


const BuilderToolbar = ({
    portfolioType,
    onEqualWeight,
    onLockAll,
    onUnlockAll,
    onProRataFill,
    onScaleUp,
    onScaleDown,
    onTickerSearch,
    onPortfolioSelection,
    onFetchBlendedTimeseries,
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [currentValue, setCurrentValue] = useState(1);
    const [modalTitle, setModalTitle] = useState('');
    const [scaleAction, setScaleAction] = useState(null);

    const showModalForScale = (action) => {
        setModalTitle('Proportional Scaler');
        setIsModalVisible(true);
        setModalContent('scale');
        setScaleAction(() => (value) => action(value));
    };

    const showModalForAction = (actionType) => {
        setModalTitle(actionType === 'tickerSearch' ? 'Search for Tickers' : 'Search your Portfolios');
        setIsModalVisible(true);
        setModalContent(actionType);
    };

    const handleOk = (value) => {
        if (modalContent === 'scale' && scaleAction) {
            scaleAction(value || currentValue);
        }
        setIsModalVisible(false);
        setCurrentValue(1);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    console.log('portfolioType', portfolioType)


    const renderModalContent = () => {
        switch (modalContent) {
            case 'tickerSearch':
                return <TickerSearch onTickersSubmit={onTickerSearch} />;
            case 'portfolioSelection':
                return <PortfolioSelector
                    onSelect={onPortfolioSelection}
                    allowTypes={getAllowedTypes(portfolioType)}
                    maxSelected={10}
                />;
            case 'scale':
                return <ScaleEntry currentValue={currentValue} onSubmit={handleOk} />;
            default:
                return null;
        }
    };

    const menu = (
        <Menu>
            <Menu.Item key="1" icon={<AddCircleRounded />} onClick={() => showModalForAction('tickerSearch')}>
                Ticker Search
            </Menu.Item>
            {portfolioType!=='b' ? (
                <Menu.Item key="2" icon={<CreateNewFolderRounded />} onClick={() => showModalForAction('portfolioSelection')}>
                    Portfolio Selection
                </Menu.Item>
            ) : (
                <Menu.Item key="2">
                    Cant Add Portfolio to Blocks
                </Menu.Item>
            )}
        </Menu>
    );

    return (
        <>
            <Space wrap style={{paddingBottom: 10}}>
                <Dropdown overlay={menu}>
                    <Button startIcon={<SearchRounded/>} size={'small'} variant={'contained'} color={'primary'} endIcon={<ExpandMore/>}>
                        Add to Portfolio
                    </Button>
                </Dropdown>
                <ButtonGroup size={'small'} variant={'contained'} color={'inherit'} className={'ml-6'}>
                    <Tooltip title="Equal Weighting">
                        <Button  onClick={onEqualWeight} startIcon={<BalanceRounded fontSize={'small'} />}> Weight Equal</Button>
                    </Tooltip>
                    <Tooltip title="Pro Rata Fill to 100%">
                        <Button onClick={onProRataFill} startIcon={<ScaleRounded fontSize={'small'}/>}>Fill to 100%</Button>
                    </Tooltip>
                    <Tooltip title="Lock All">
                        <Button  onClick={onLockAll}><LockRounded fontSize={'small'} /></Button>
                    </Tooltip>
                    <Tooltip title="Unlock All">
                        <Button danger onClick={onUnlockAll}><LockOpenRounded fontSize={'small'} /></Button>
                    </Tooltip>
                    <Tooltip title="Scale Up">
                        <Button onClick={() => showModalForScale(onScaleUp)}>
                            <TrendingUpRounded fontSize={'small'}/>
                        </Button>
                    </Tooltip>
                    <Tooltip ghost title="Scale Down">
                        <Button onClick={() => showModalForScale(onScaleDown)}>
                            <TrendingDownRounded fontSize={'small'}/>
                        </Button>
                    </Tooltip>
                    <Button>
                        Blend Timeseries
                    </Button>
                </ButtonGroup>
            </Space>
            <Modal width={760}
                   title={modalTitle}
                   open={isModalVisible}
                   onOk={handleOk}
                   onCancel={handleCancel}
                   footer={null}>
                {renderModalContent()}
            </Modal>
        </>
    );
};

export default BuilderToolbar;
